/**
 * Exceptions Routes - Handles nested routing for exceptions section
 */

import React from 'react'
import { Routes, Route } from 'react-router-dom'
import SharedExceptionsList from '../shared/Exceptions/SharedExceptionsList'
import DynamicExceptionRoute from './DynamicExceptionRoute'

const ExceptionsRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Canonical "All areas" view. */}
      <Route index element={<SharedExceptionsList objectType="all" />} />

      {/* /exceptions/all alias — kept so old bookmarks still resolve. */}
      <Route path="all" element={<SharedExceptionsList objectType="all" />} />

      {/* Sales exceptions list and details */}
      <Route path="sales" element={<SharedExceptionsList objectType="sales" />} />
      <Route path="sales/:exception_code" element={<DynamicExceptionRoute />} />

      {/* Stock management exceptions (inventory sub-domain: stock levels & movement) */}
      <Route path="stock-management" element={<SharedExceptionsList objectType="stock-management" />} />
      <Route path="stock-management/:exception_code" element={<DynamicExceptionRoute />} />

      {/* Product setup exceptions (inventory sub-domain: catalog hygiene) */}
      <Route path="product-setup" element={<SharedExceptionsList objectType="product-setup" />} />
      <Route path="product-setup/:exception_code" element={<DynamicExceptionRoute />} />

      {/* Product pricing exceptions (inventory sub-domain: cost & price integrity) */}
      <Route path="product-pricing" element={<SharedExceptionsList objectType="product-pricing" />} />
      <Route path="product-pricing/:exception_code" element={<DynamicExceptionRoute />} />

      {/* Systems exceptions list and details */}
      <Route path="systems" element={<SharedExceptionsList objectType="systems" />} />
      <Route path="systems/:exception_code" element={<DynamicExceptionRoute />} />

      {/* Client (customer) exceptions list and details */}
      <Route path="client" element={<SharedExceptionsList objectType="client" />} />
      <Route path="client/:exception_code" element={<DynamicExceptionRoute />} />

      {/* Accounting exceptions list and details */}
      <Route path="accounting" element={<SharedExceptionsList objectType="accounting" />} />
      <Route path="accounting/:exception_code" element={<DynamicExceptionRoute />} />
    </Routes>
  )
}

export default ExceptionsRoutes
